/* eslint-disable array-element-newline */

const experiments = {
  // Sample
  "111": {
    "createdAt": "1970-01-01T00:00:00.000Z",
    "description": "A sample to refer to when adding experiments",
    // Change this to an index to force that variation
    "forceIndex": null,
    "name": "sampleExperiment",
    "variations": ["these", "strings", "for", "loggin", "or", "analytics"]
  },
  "11174121990": {
    "createdAt": "2018-08-01T19:26:14.120Z",
    "description": "Rewrite metal tone question",
    "forceIndex": 0,
    "name": "styleSurveyPartOne",
    "variations": ["control", "variation 1: new metal tone"]
  },
  "11216353428": {
    "createdAt": "2018-08-10T19:12:50.870Z",
    "description": "Shorter survey",
    "forceIndex": null,
    "name": "styleSurveyPartTwo",
    "variations": ["control", "variation 1: shorter survey", "variation 2: shorter survey w/splash"]
  },
  "11927534872": {
    "createdAt": "2018-11-02T17:18:37.022Z",
    "description": "Survey splash",
    "forceIndex": null,
    "name": "styleSurveyPartThree",
    "variations": ["control", "variation 1: with splash"]
  }
};

Object.freeze(experiments);

export {experiments};

/*
 * Setting forces should only be for dev/QA testing or for productization
 * And will override any optimizely settings
 */
const getForces = () => Object.values(experiments).reduce( // eslint-disable-line one-var
  (returnObj, experiment) => typeof experiment.forceIndex === "number"
    ? Object.assign(returnObj, {[experiment.name]: experiment.forceIndex})
    : returnObj,
  {}
);

export const getExperimentVariants = function getExperimentVariants () { // eslint-disable-line one-var
  const {optimizely} = window;
  const forces = getForces();

  // They may have ad-block...
  let variationMap = {};

  try {
    if (optimizely) {
      variationMap = optimizely.get("state").getVariationMap(); // eslint-disable-line one-var
    }
  } catch (err) {
    return forces;
  }

  return Object.assign(
    Object.keys(variationMap).reduce(
      (returnObj, experimentId) => {
        try {
          const experiment = experiments[experimentId];
          return Object.assign(
            {...returnObj},
            // This maps the variation index to our internal experiment name (e.g. styleSurveyPartOne: 1)
            {[experiment.name]: variationMap[experimentId].index}
          );
        } catch (err) {
          return returnObj;
        }
      },
      {}
    ),
    forces
  );
};

export default {
  experiments,
  getExperimentVariants
};
